import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../../../core/auth/services/config.service';
import { Observable } from 'rxjs';
import { HydrationHistoryResponse } from '../hydration-const/hydration-details-models';
import { TimePeriodFilter } from '../../assesment-detail/assesment-const/assessment-details-models';

@Injectable({
  providedIn: 'root',
})
export class HydrationDetailsService {
  private httpClient = inject(HttpClient);
  private configService = inject(ConfigService);
  private baseUrl = this.configService.getPatientAPIUrl();
  private apiUrl = this.configService.getAPIUrl(); // v2

  constructor() {}

  getHydrationHistory(
    patientId: string,
    filter?: TimePeriodFilter,
  ): Observable<HydrationHistoryResponse> {
    let url = `${this.apiUrl}/api/WaterTracking/history?Patient_id=${patientId}`;
    if (filter) {
      url += `&hydration_filter=${filter}`;
    }
    return this.httpClient.get<HydrationHistoryResponse>(url);
  }
}
